setPmScreenAction